import KeenSlider from 'keen-slider';
import { query } from '../core/dom.js';

export function initEcoSlider(ctx) {
  const track = query('[data-home-eco-slider-track]');
  if (!track) {
    return ctx;
  }

  const container = track.closest('[data-home-eco-slider]');
  const prevBtn = container?.querySelector('[data-home-eco-prev]');
  const nextBtn = container?.querySelector('[data-home-eco-next]');
  const currentDisplay = container?.querySelector('[data-home-eco-current]');
  const progressBar = container?.querySelector('[data-home-eco-progress]');
  const totalDisplayEl = container?.querySelector('.home-eco-slider__progress-number--total');
  const totalDisplayValue = parseInt(totalDisplayEl?.textContent ?? '01', 10) || 1;

  ctx.ecoSliderInstance = new KeenSlider(track, {
    loop: true,
    mode: 'snap',
    defaultAnimation: {
      duration: 3000,
    },
    detailsChanged: (s) => {
      s.slides.forEach((element, idx) => {
        element.style.opacity = s.track.details.slides[idx].portion;
      });
    },
  });

  const refreshProgress = () => {
    if (track) {
      track.style.transform = 'translate3d(0, 0, 0)';
      track.style.transition = 'none';
    }

    if (!ctx.ecoSliderInstance) {
      return;
    }

    const details = ctx.ecoSliderInstance.track.details;
    const safeIndex = Math.max(0, Math.min(details.rel, details.slides.length - 1));
    const maxIndex = Math.max(1, totalDisplayValue - 1);
    const displayNumber = Math.min(safeIndex + 1, totalDisplayValue);
    const progressPercent = (safeIndex / maxIndex) * 100;
    const slides = Array.from(track.querySelectorAll('.keen-slider__slide'));
    slides.forEach((slide, idx) => {
      slide.classList.toggle('is-active', idx === safeIndex % slides.length);
    });

    if (currentDisplay) {
      currentDisplay.textContent = String(displayNumber).padStart(2, '0');
    }

    if (progressBar) {
      progressBar.style.transform = `scaleX(${Math.min(progressPercent, 100) / 100})`;
    }
  };

  ctx.ecoSliderInstance.on('created', refreshProgress);
  ctx.ecoSliderInstance.on('slideChanged', refreshProgress);

  prevBtn?.addEventListener('click', () => {
    ctx.ecoSliderInstance?.prev();
  });

  nextBtn?.addEventListener('click', () => {
    ctx.ecoSliderInstance?.next();
  });

  return ctx;
}
